import { CalendarPlus } from 'lucide-react';
import { Button } from '@/app/_components/core/button';
import { SmartLink } from '@/app/_components/core/smart-link';

export interface CardButtonProps {
  detailLink: string;
  label: string;
  size: 'sm' | 'default' | 'lg';
  className?: string;
  trackingPrefix?: string;
}

export function CardButton({
  detailLink,
  label,
  size,
  className,
  trackingPrefix,
}: CardButtonProps) {
  return (
    <Button asChild variant="default" size={size} className={className}>
      <SmartLink
        href={detailLink}
        data-track-id={
          trackingPrefix ? `${trackingPrefix}-detail` : undefined
        }
      >
        <CalendarPlus className="mr-2 size-4 " />
        {label}
      </SmartLink>
    </Button>
  );
}
